import { EllipsedText, Loading, VirtualizedComponent } from '@gorila-shared-ui/components';
import { ListItem, ListItemLabel } from 'baseui/list';
import { CSSProperties, memo, useRef } from 'react';
import { ListChildComponentProps } from 'react-window';
import { useRecoilState, useRecoilValue } from 'recoil';
import { useHover } from 'usehooks-ts';
import { SMALL_LIST_ITEM_HEIGHT } from '../../../constants/app';
import { useStyles } from '../../../hooks/useStyles';
import { selectedUserIdState, userState } from '../../../storage/users';

function UserItem({ data, index, style }: Readonly<ListChildComponentProps<VirtualizedComponent['data']>>) {
  const { overrides } = useStyles();
  const [selectedUserId, setSelectedUserId] = useRecoilState(selectedUserIdState);
  const userId = data.items[index];
  const user = useRecoilValue(userState(userId));
  const hoverRef = useRef(null);
  const isHover = useHover(hoverRef);

  const isSelected = selectedUserId === userId;

  const onSelectUser = () => {
    if (selectedUserId === userId) setSelectedUserId(undefined);
    else setSelectedUserId(userId);
  };

  return (
    <span
      style={style as CSSProperties}
      ref={hoverRef}
    >
      {data.isLoaded(index) ? (
        <ListItem
          overrides={overrides.listItemOverrides({
            onClick: onSelectUser,
            isHover,
            isSelected,
            minHeight: SMALL_LIST_ITEM_HEIGHT,
          })}
        >
          <ListItemLabel>
            <EllipsedText inline>{user?.username || '-'}</EllipsedText>
          </ListItemLabel>
        </ListItem>
      ) : (
        <Loading size="compact" />
      )}
    </span>
  );
}

export default memo(UserItem);
